import React from 'react'
import {
  MobileActionCard,
  MobileDateRangeSearchCard,
  MobileTabbedReportLayout
} from '../../../components/mobile'
import ReportEffectivenessMobileDownload from './ReportEffectivenessMobileDownload'
import ReportEffectivenessMobileDateRangeSearch from './ReportEffectivenessMobileDateRangeSearch'
import ReportSummaryMobileTab from './ReportSummaryMobileTab'
import ReportChargesMobileTab from './ReportChargesMobileTab'
import ReportDeliveriesMobileTab from './ReportDeliveriesMobileTab'
import ReportOrdersMobileTab from './ReportOrdersMobileTab'
import ReportPosMobileTab from './ReportPosMobileTab'
import ReportRefundsMobileTab from './ReportRefundsMobileTab'

const REPORT_MOBILE_TAB_COMPONENTS = {
  summary: ReportSummaryMobileTab,
  charges: ReportChargesMobileTab,
  deliveries: ReportDeliveriesMobileTab,
  orders: ReportOrdersMobileTab,
  pos: ReportPosMobileTab,
  refunds: ReportRefundsMobileTab
}

export default function EffectivenessIndexMobileLayout({
  tabs,
  activeTab,
  setActiveTab,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  today,
  searchFromDates,
  hasError,
  isFetching,
  selectedTab,
  activeTabTitle,
  kpiData,
  data,
  currentPage,
  totalPages,
  onPaginationPageChange,
  handlePaginationClick,
  searchQuery,
  onSearchQuery,
  onRowClick,
  userExpandableCardFontSize,
  hasPendingSettlementQuery = '',
  isSingleDayRange = true,
  showSettlementFilter = false,
  pendingSettlementFilter = null,
  onPendingSettlementFilterChange = null,
  isSettlementFilterDisabled = false
}) {
  const sharedTabProps = {
    title: activeTabTitle,
    activeTab,
    selectedTab,
    kpiData,
    data,
    currentPage,
    totalPages,
    handlePaginationClick,
    searchQuery,
    onSearchQuery,
    onRowClick,
    userExpandableCardFontSize,
    isSingleDayRange,
    showSettlementFilter,
    pendingSettlementFilter,
    onPendingSettlementFilterChange,
    isSettlementFilterDisabled
  }

  const MobileTabBody = REPORT_MOBILE_TAB_COMPONENTS[activeTab]

  return (
    <MobileTabbedReportLayout
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={(tabKey) => setActiveTab(tabKey)}
      hasError={hasError}
      isFetching={isFetching}
      loadingMinHeight="calc(100dvh - 220px)"
      currentPage={currentPage}
      totalPages={totalPages}
      onPaginationPageChange={onPaginationPageChange}
      handlePaginationClick={handlePaginationClick}
      filterContent={
        <MobileDateRangeSearchCard>
          <ReportEffectivenessMobileDateRangeSearch
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            maxDateStr={today}
            onSearch={searchFromDates}
          />
        </MobileDateRangeSearchCard>
      }
      actionContent={
        <MobileActionCard>
          <ReportEffectivenessMobileDownload
            activeTab={activeTab}
            startDate={startDate}
            endDate={endDate}
            searchQuery={searchQuery}
            hasPendingSettlementQuery={hasPendingSettlementQuery}
          />
        </MobileActionCard>
      }
    >
      {MobileTabBody ? <MobileTabBody {...sharedTabProps} /> : null}
    </MobileTabbedReportLayout>
  )
}
